(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function money(n) { return '$' + Math.round(n).toLocaleString('en-US'); }

  function countdowns(scope) {
    scope.querySelectorAll('[data-fm-countdown]').forEach(function (el) {
      if (el.dataset.ready) return; el.dataset.ready = '1';
      var hours = Number(el.dataset.hours) || 12, key = 'fm-cd-end', end;
      try { end = Number(localStorage.getItem(key)); } catch (e) {}
      if (!end || end < Date.now()) { end = Date.now() + hours * 3600e3; try { localStorage.setItem(key, end); } catch (e) {} }
      var h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
      function tick() {
        var left = Math.max(0, end - Date.now()), t = Math.floor(left / 1000);
        h.textContent = String(Math.floor(t / 3600)).padStart(2, '0');
        m.textContent = String(Math.floor(t / 60) % 60).padStart(2, '0');
        s.textContent = String(t % 60).padStart(2, '0');
      }
      tick(); setInterval(tick, 1000);
    });
  }

  function galleries(scope) {
    scope.querySelectorAll('[data-fm-gal]').forEach(function (g) {
      if (g.dataset.ready) return; g.dataset.ready = '1';
      var track = g.querySelector('.fm-gal__track'), thumbs = g.querySelectorAll('.fm-gal__thumb');
      function go(i) { track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); }
      function cur() { return Math.round(track.scrollLeft / track.clientWidth); }
      g.querySelector('.fm-gal__arrow--prev').addEventListener('click', function () { go(Math.max(0, cur() - 1)); });
      g.querySelector('.fm-gal__arrow--next').addEventListener('click', function () { var n = track.children.length; go((cur() + 1) % n); });
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
      track.addEventListener('scroll', function () { var c = cur(); thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === c); }); }, { passive: true });
    });
  }

  function tabs(scope) {
    scope.querySelectorAll('[data-fm-tabs]').forEach(function (t) {
      if (t.dataset.ready) return; t.dataset.ready = '1';
      var btns = t.querySelectorAll('[data-fm-tab]'), panels = t.querySelectorAll('[data-fm-panel]');
      btns.forEach(function (b) { b.addEventListener('click', function () {
        btns.forEach(function (x) { x.classList.toggle('is-active', x === b); });
        panels.forEach(function (p) { p.hidden = p.dataset.fmPanel !== b.dataset.fmTab; });
      }); });
    });
  }

  function modals(scope) {
    scope.querySelectorAll('[data-fm-open]').forEach(function (b) {
      if (b.dataset.ready) return; b.dataset.ready = '1';
      b.addEventListener('click', function () { var m = document.getElementById(b.dataset.fmOpen); if (m) m.classList.add('is-open'); });
    });
    scope.querySelectorAll('.fm-modal').forEach(function (m) {
      if (m.dataset.ready) return; m.dataset.ready = '1';
      m.addEventListener('click', function (e) { if (e.target === m || e.target.closest('.fm-modal__close')) m.classList.remove('is-open'); });
    });
  }

  function buyBoxes(scope) {
    scope.querySelectorAll('[data-fm-buy]').forEach(function (box) {
      if (box.dataset.ready) return; box.dataset.ready = '1';
      var bundles = box.querySelectorAll('[data-fm-bundle]'), now = box.querySelector('[data-fm-now]'),
          was = box.querySelector('[data-fm-was]'), save = box.querySelector('[data-fm-save]'),
          btn = box.querySelector('[data-fm-atc]'), variant = box.dataset.variant, qty = 1;
      function pick(b) {
        bundles.forEach(function (x) { x.classList.toggle('is-active', x === b); x.setAttribute('aria-pressed', x === b); });
        qty = Number(b.dataset.qty);
        var p = Number(b.dataset.price), c = Number(b.dataset.compare);
        now.textContent = money(p); was.textContent = c > p ? money(c) : '';
        save.hidden = !(c > p); save.textContent = 'AHORRA ' + Math.round((1 - p / c) * 100) + '%';
      }
      bundles.forEach(function (b) { b.addEventListener('click', function () { pick(b); }); });
      var def = box.querySelector('[data-fm-bundle][data-default]') || bundles[0]; if (def) pick(def);
      var d = box.querySelector('[data-fm-date]');
      if (d) { var dt = new Date(Date.now() + Number(d.dataset.days || 7) * 864e5); d.textContent = dt.toLocaleDateString('es-MX', { day: 'numeric', month: 'long' }); }
      btn.addEventListener('click', function () {
        var items = [{ id: Number(variant), quantity: qty }];
        box.querySelectorAll('.fm-addon input:checked').forEach(function (i) { items.push({ id: Number(i.value), quantity: 1 }); });
        btn.setAttribute('aria-busy', 'true'); var label = btn.textContent; btn.textContent = 'Agregando…';
        fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { if (!r.ok) throw r; location.href = root + 'cart'; })
          .catch(function () { btn.removeAttribute('aria-busy'); btn.textContent = label; alert('No se pudo agregar al carrito. Inténtalo de nuevo.'); });
      });
    });
  }

  function minis(scope) {
    scope.querySelectorAll('[data-fm-mini]').forEach(function (m) {
      if (m.dataset.ready) return; m.dataset.ready = '1';
      var track = m.querySelector('.fm-mini__track'), dots = m.querySelectorAll('.fm-mini__dots i'), n = track.children.length, i = 0;
      function show(k) { i = k; track.scrollTo({ left: k * track.clientWidth, behavior: 'smooth' }); dots.forEach(function (d, j) { d.classList.toggle('is-active', j === k); }); }
      setInterval(function () { if (n > 1) show((i + 1) % n); }, 5000);
    });
  }

  function reviews(scope) {
    scope.querySelectorAll('[data-fm-reviews]').forEach(function (r) {
      if (r.dataset.ready) return; r.dataset.ready = '1';
      var items = r.querySelectorAll('.fm-rev'), more = r.querySelector('[data-fm-more]'), step = 3, shown = step, topic = 'all';
      function render() {
        var visible = 0;
        items.forEach(function (it) {
          var match = topic === 'all' || (it.dataset.topics || '').indexOf(topic) > -1;
          it.hidden = !match || visible >= shown; if (match && visible < shown) visible++;
        });
        var total = [].filter.call(items, function (it) { return topic === 'all' || (it.dataset.topics || '').indexOf(topic) > -1; }).length;
        if (more) more.hidden = shown >= total;
      }
      r.querySelectorAll('[data-fm-topic]').forEach(function (c) { c.addEventListener('click', function () {
        r.querySelectorAll('[data-fm-topic]').forEach(function (x) { x.classList.toggle('is-active', x === c); });
        topic = c.dataset.fmTopic; shown = step; render();
      }); });
      if (more) more.addEventListener('click', function () { shown += step; render(); });
      render();
    });
  }

  function init(scope) { countdowns(scope); galleries(scope); tabs(scope); modals(scope); buyBoxes(scope); minis(scope); reviews(scope); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
